import ReactQuill from "react-quill";

const WysiwygEditor = (props) => {
  const modules = {
    toolbar: [
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike"],
    ],
  };
  return (
    <ReactQuill theme="snow" modules={modules} preserveWhitespace {...props} />
  );
};

export default WysiwygEditor;
